"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("../common/constants");

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Utils = /*#__PURE__*/_createClass(function Utils() {
  _classCallCheck(this, Utils);
});

_defineProperty(Utils, "replaceKeysWithAliasName", function (dataCols, data, type, callbackFunction) {
  if (dataCols !== null && dataCols !== void 0 && dataCols.length) {
    if (callbackFunction) {
      callbackFunction("liveDataStatus ".concat(type), 'Processing Data');
    }

    var columnMapping = dataCols[0];
    var dataString = JSON.stringify(data);

    for (var key in columnMapping) {
      if (columnMapping.hasOwnProperty(key)) {
        dataString = dataString.replaceAll("\"".concat(key, "\""), "\"".concat(columnMapping[key], "\""));
      }
    }

    return JSON.parse(dataString);
  }

  return data;
});

_defineProperty(Utils, "getSVGType", function (type) {
  switch (type) {
    case "circuitBreakerOpen":
    case "circuitBreakerClosed":
    case "circuitBreakerClosedHorizontal":
    case "circuitBreakerOpenHorizontal":
    case "circuitBreakerVerticalRaw":
    case "circuitBreakerHorizontalRaw":
    case "doublePointCircuitBreakerOpenRaw":
    case "doublePointCircuitBreakerOpen":
    case "doublePointCircuitBreakerClosed":
    case "doublePointCircuitBreakerReady":
    case "doublePointCircuitBreakerOpenRawHz":
    case "doublePointCircuitBreakerOpenHz":
    case "doublePointCircuitBreakerClosedHz":
    case "doublePointCircuitBreakerReadyHz":
      return "circuitBreaker";

    default:
      return type;
  }
});

_defineProperty(Utils, "getCBColor", function (DICurrentStatus, zerosColor, onesColor) {
  switch (DICurrentStatus) {
    case 0:
      return zerosColor;

    case 1:
      return onesColor;

    default:
      return _constants.CB.singlePoint[99];
  }
});

_defineProperty(Utils, "getSVGColor", function (asset) {
  var _asset$diData, _asset$diData2, _asset$diData3;

  var isDynamicColorEnabled = (asset === null || asset === void 0 ? void 0 : (_asset$diData = asset.diData) === null || _asset$diData === void 0 ? void 0 : _asset$diData.ZerosColor) && (asset === null || asset === void 0 ? void 0 : (_asset$diData2 = asset.diData) === null || _asset$diData2 === void 0 ? void 0 : _asset$diData2.OnesColor);
  var zerosColor = asset.zerosColor;
  var onesColor = asset.onesColor;
  var isDoublePoint = asset === null || asset === void 0 ? void 0 : asset.DoublePoint;
  var DICurrentStatus = Number((asset === null || asset === void 0 ? void 0 : (_asset$diData3 = asset.diData) === null || _asset$diData3 === void 0 ? void 0 : _asset$diData3.DICurrentStatus) || 99); //default DI for color 99
  // this logic will apply for single and double point as well for dynamic color

  if (isDynamicColorEnabled) {
    return asset === null || asset === void 0 ? void 0 : asset.diData[_constants.CB.colorTextValues[DICurrentStatus]];
  }

  if (isDoublePoint) {
    return _constants.CB.doublePoint[DICurrentStatus];
  }

  return Utils.getCBColor(DICurrentStatus, zerosColor || _constants.CB.singlePoint[0], onesColor || _constants.CB.singlePoint[1]);
});

_defineProperty(Utils, "isBreakerSVG", function (asset) {
  return asset !== null && asset !== void 0 && asset.altTxt_orig ? Utils.getSVGType(asset.altTxt_orig) === "circuitBreaker" : asset.className === "breaker";
});

_defineProperty(Utils, "calculateTitleText", function (asset) {
  if (asset.txId === 0) return asset.altTxt;
  var baseTitleText = "".concat(_constants.core.ASSET_PREFIX + asset.txId, " ").concat(asset.left, ", ").concat(parseInt(asset.top) + _constants.core.HEADER_OFFSET).concat(_constants.core.sizeOfElements.unit, " ").concat(asset.altTxt, "\n AssetId: ").concat((asset === null || asset === void 0 ? void 0 : asset.assetId) || 'N/A');

  if (Utils.isDIAssociatedClass(asset.className) && asset.txId !== 0) {
    var _asset$diData4;

    var pointType = asset.className === 'breaker' || asset.className === 'isolator' ? (asset === null || asset === void 0 ? void 0 : asset.DoublePoint) === true ? 'Double Point' : 'Single Point' : 'N/A';
    return "".concat(baseTitleText, "\n    Asset Name: ").concat(asset.assetName || 'N/A', "\n    DISettingId: ").concat(asset.assetDISettingId || 'N/A', "\n    DISetting Name: ").concat(asset.assetDISettingName || 'N/A', "\n    Status: ").concat((asset === null || asset === void 0 ? void 0 : (_asset$diData4 = asset.diData) === null || _asset$diData4 === void 0 ? void 0 : _asset$diData4.DICurrentStatusText) || 'N/A', "\n    Type: ").concat(pointType);
  }

  return baseTitleText;
});

_defineProperty(Utils, "isDIAssociatedClass", function (assetClass) {
  return assetClass === 'isolator' || assetClass === 'breaker' || assetClass === 'relay' ? true : false;
});

var _default = Utils;
exports.default = _default;